import { GridApi } from '@mui/x-data-grid-premium';
import { Column } from '../types';

export const handleClipboardCopy = (apiRef: React.MutableRefObject<GridApi>) => {
  if (!apiRef?.current) return;

  const cellSelectionModel = apiRef.current.getCellSelectionModel();
  const selectedCells: string[] = [];

  Object.entries(cellSelectionModel).forEach(([rowId, columns]) => {
    const row = apiRef.current.getRow(rowId);
    const selectedData = Object.keys(columns)
      .filter((field) => columns[field])
      .map((field) => {
        const rawValue = row?.[field] ?? '';
        const colDef = apiRef.current.getColumn(field) as unknown as Column;

        //Only treat as date if it's an actual Date or ISO date string
        const isValidDate =
          rawValue instanceof Date ||
          (typeof rawValue === 'string' &&
            /^\d{4}-\d{2}-\d{2}/.test(rawValue) &&
            !isNaN(Date.parse(rawValue)));

        if (isValidDate) {
          const date = new Date(rawValue);
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const year = date.getFullYear();
          return `${day}/${month}/${year}`;
        }

        // Handle singleSelect (Dropdowns) by mapping value to label
        const options = colDef?.valueOptions;
        if (Array.isArray(options)) {
          const found = options.find((opt: any) =>
            typeof opt === 'object' ? opt.value === rawValue : opt === rawValue,
          );
          if (found) {
            return typeof found === 'object' ? found.label : found;
          }
        }

        if (colDef?.valueFormatter) {
          try {
            return colDef.valueFormatter({
              value: rawValue,
              row,
              column: colDef,
              api: apiRef.current,
            }).value;
          } catch (err) {
            console.error(`valueFormatter failed for field "${field}"`, err);
          }
        }

        return rawValue;
      })
      .join('\t');

    selectedCells.push(selectedData);
  });

  const finalCopyString = selectedCells.join('\n');
  navigator.clipboard.writeText(finalCopyString);
};
